<template>
    <main class="main" id="main">
        <navigate></navigate>
        <section class="section s-lk">
            <div class="container">
                <div class="presents_box">
                    <div class="header">
                        <button class="menu_item_btn green" @click="addPresent">ДОБАВИТЬ ПОДАРОК</button>
                    </div>
                    <table class="table" id="present_table">
                        <div class="wrapper">
                            <div class="dataTables_length" id="restaurant_table_length"></div>
                        </div>
                        <thead>
                        <tr class="row">
                            <th>Название</th>
                            <th>Категория</th>
                            <th>Страна</th>
                            <th>Город</th>
                            <th>Стоимость</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row" v-for="(present, index) in presents" :key="index">
                            <td class="td">{{present.name}}</td>
                            <td class="td">{{present.cat}}</td>
                            <td class="td">{{present.country}}</td>
                            <td class="td">{{present.city}}</td>
                            <td class="td">{{present.price}}</td>
                            <td class="td">
                                <router-link tag="button" :to="'/lk/present/' + present.id" class="open_btn">Открыть</router-link>
                                <button class="open_btn" v-if="present.delete" @click="deletePresent(present.id)" style="margin-top: 5px;background: red;font-size: 10px;padding: 3px 15px;">удалить</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

    </main>

</template>

<script>
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
import axios from '@/router/http'
import Navigate from '@/pages/lk/user/navigate'
export default {
  name: 'restaurants',
  components: {Navigate},
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      range: {},
      presents: []
    }
  },
  mounted () {
  },
  methods: {
    deletePresent (id) {
      if (confirm('Вы действительно хотите удалить подарок? ОТМЕНИТЬ УДАЛЕНИЕ НЕВОЗМОЖНО!')) {
        var formData = new FormData()
        formData.append('uid', this.auth.uid)
        formData.append('id', id)
        axios.post('https://lk.when-hungry.com/mobile/delete-present',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          alert('Подарок удален')
        })
      }
    },
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/get-presents?uid=' + this.auth.uid).then(response => {
        this.presents = response.data
      })
    },
    addPresent () {
      var formData = new FormData()
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/new-present',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          window.location.href = '/lk/present/' + response.data.id
        }
      })
    }
  },
  watch: {
    presents () {
      if ($('#present_table.dataTable').length) $('#present_table').DataTable().destroy()
      setTimeout(() => {
        $('#present_table').DataTable({
          'order': [[0, 'desc']],
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          },
          'scrollX': true
        })
      }, 300)
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/presents.vue